import http from "../http-common";

export default class LoginService {

  login(wachtwoord) {
    return http.post("/api/auth/login", { password: wachtwoord });
  }
}
